var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyNairaFlex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.3333V6.66667C2.5 5.74619 3.24619 5 4.16667 5H15.8333C16.7538 5 17.5 5.74619 17.5 6.66667V13.3333C17.5 14.2538 16.7538 15 15.8333 15H4.16667C3.24619 15 2.5 14.2538 2.5 13.3333Z",
    stroke: "#EA417D",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.83333V5.83333C5.83333 7.21404 4.71404 8.33333 3.33333 8.33333V8.33333",
    stroke: "#EA417D",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 14.1667V14.1667C5.83333 12.786 4.71404 11.6667 3.33333 11.6667V11.6667",
    stroke: "#EA417D",
    strokeWidth: 1.66667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.83333V5.83333C14.1667 7.21404 15.286 8.33333 16.6667 8.33333V8.33333",
    stroke: "#EA417D",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1667V14.1667C14.1667 12.786 15.286 11.6667 16.6667 11.6667V11.6667",
    stroke: "#EA417D",
    strokeWidth: 1.66667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 11.6667V8.33333L11.6667 11.6667V8.33333",
    stroke: "#EA417D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10L12.5 10",
    stroke: "#EA417D",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyNairaFlex);
export default __webpack_public_path__ + "static/media/MoneyNairaFlex.758bd2fc7dd96224dc237337b05038ee.svg";
export { ForwardRef as ReactComponent };